<div
  class="tw-relative tw-flex tw-h-[min(900px,calc(100dvh-32px))] tw-max-h-[calc(100dvh-32px)] tw-flex-col tw-overflow-hidden"
>
  <!-- 閉じるボタン -->
  <button
    id="close-btn"
    class="!tw-absolute tw-top-1 tw-right-1 !tw-z-10 !tw-flex"
    mat-icon-button
    mat-dialog-close
  >
    <mat-icon>close</mat-icon>
  </button>

  <div mat-dialog-title class="matp-dialog-title">{{ dialogTitle }}</div>

  <mat-dialog-content
    class="!tw-flex tw-w-full tw-flex-1 tw-min-h-0 tw-flex-col tw-overflow-hidden !tw-pt-6 !tw-max-h-none"
  >
    <div class="tw-flex tw-w-full tw-flex-none tw-gap-8">
      <div
        class="tw-min-w-0 tw-flex-1 tw-truncate tw-self-start"
        [matTooltip]="shipment?.shipmentName || ''"
      >
        配送名：{{ shipment?.shipmentName }}
      </div>
      <div class="tw-min-w-0 tw-flex-1 tw-whitespace-nowrap">
        デバイス名：{{ shipment?.deviceName || "削除済デバイス" }}
      </div>
      <div class="tw-min-w-0 tw-max-w-64 tw-flex-1 tw-whitespace-nowrap">
        配送ステータス詳細：{{ shipment?.shipmentStatus }}
      </div>
      @if (!hideAlertSections) {
        <div
          class="tw-flex tw-min-w-[450px] tw-flex-1 tw-gap-4 tw-whitespace-nowrap"
        >
          <div class="tw-flex tw-min-w-0 tw-flex-col">
            <div>
              配送センサー上限アラート:
              {{ shipment?.countSummary?.alertMaxCount }}
            </div>
            <div>
              配送センサー下限アラート:
              {{ shipment?.countSummary?.alertMinCount }}
            </div>
            <div>
              配送センサーアラート:
              {{ shipment?.countSummary?.alertEventCount }}
            </div>
          </div>
          <div class="tw-flex tw-min-w-0 tw-flex-col">
            <div>
              上限ワーニング:
              {{ shipment?.countSummary?.warningMaxCount }}
            </div>
            <div>
              下限ワーニング:
              {{ shipment?.countSummary?.warningMinCount }}
            </div>
          </div>
        </div>
      }
    </div>

    <div class="tw-flex tw-flex-1 tw-min-h-0 tw-gap-4 tw-pt-4">
      @if (!hideAlertSections) {
        <div class="tw-flex tw-min-h-0 tw-min-w-0 tw-flex-1 tw-basis-0">
          <app-shipment-sensor-alert-detail
            class="tw-flex-1 tw-min-h-0"
            [alertList]="shipmentSensorAlert"
            [selectedMarker]="selectedSensorAlertMarker"
            (alertDetailChanged)="onSensorAlertDetailChanged($event)"
          ></app-shipment-sensor-alert-detail>
        </div>
      }

      <div class="tw-flex tw-min-h-0 tw-min-w-0 tw-flex-1 tw-basis-0">
        <app-shipment-alert-map
          class="tw-flex-1 tw-min-h-0"
          [deviceInfoList]="shipmentDeviceInfoHistory"
          [currentLocation]="location"
          [route]="route"
          [mapHeight]="'100%'"
          [startDatetime]="startDatetime"
          [arrivalDatetime]="arrivalDatetime"
          [statusHistory]="statusHistory"
          [selectedSensorAlertDetail]="selectedSensorAlertDetail"
          [selectedMarker]="selectedSensorAlertMarker"
          [deviceLocationDisplayed]="!shipment?.isBeforeReady"
          (markerChanged)="onMarkerChanged($event)"
          mapId="dialog-map"
        ></app-shipment-alert-map>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions
    class="!tw-flex !tw-h-auto tw-flex-none !tw-justify-center tw-gap-4 !tw-px-6 !tw-pt-3 !tw-pb-4"
  >
    <button
      mat-raised-button
      mat-dialog-close
      class="!tw-min-w-40 tw-my-0 tw-mx-3"
    >
      <mat-icon>close</mat-icon>
      閉じる
    </button>
  </mat-dialog-actions>
</div>
